import { Component, Inject } from '@angular/core';
import { ApiService } from '../../../../shared/services/api.service';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-iaproposalworkorderstatus',
  templateUrl: './iaproposalworkorderstatus.component.html',
  styleUrl: './iaproposalworkorderstatus.component.css'
})
export class IaproposalworkorderstatusComponent {
  userType = sessionStorage.getItem('UserType');

  constructor(private router: Router, private apiService: ApiService,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any) {   
  }
  
  isIAWorkOrderStatus(): boolean {
    return this.userType === 'IA' && this.data && this.data[0];
  }

  onViewProposal(proposalUserId: string, action: string): void {
    // Implement approval logic here
    this.dialog.closeAll();
    this.router.navigate(['/proposalverificationdetails', proposalUserId, action]);
  }
}
